import { useQuery } from '@apollo/client';
import { FETCH_CONFIG } from '../components/Product/ProductSidebarClub/ProductSidebarClub';
import { useCartContext } from '../context/CartContext';

const useLoyaltyPoints = () => {
  const { cart } = useCartContext();
  const grandTotal = cart && cart.prices.grand_total.value;

  const { data: config, loading } = useQuery(FETCH_CONFIG);
  const rate = config && config.backendConfig.shop.loyaltyConversion;
  const loyaltyPoints = rate && Math.floor(grandTotal / rate);
  const loyaltyPointsBanking = loyaltyPoints && loyaltyPoints * 2;

  return { loyaltyPoints, loyaltyPointsBanking, loading };
};

export default useLoyaltyPoints;
